// extracted by mini-css-extract-plugin
export default {"LockDescription":"LockDescription_LockDescription__u2erG"};